var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vimeo-player"},[_c('iframe',{ref:"vimeo",attrs:{"src":("https://player.vimeo.com/video/" + (_vm.slide.vimeo_id)),"frameborder":"0","allow":"fullscreen","allowfullscreen":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }